import { ContainerParams, ContainerTypes } from "@/types/containerTypes";
import { RepeatingStep } from "./repeatingStep";
import { RepeatingStepChild } from "./repeatingStepChild";
import { Scenario } from "./scenario";
import { Section } from "./section";
import { Step } from "./step";
import { Container } from "./container";
import { FunctionCall } from "./functionCall";

export class ContainerBuilder {
  public build<T extends ContainerParams, C extends Container>(data: T): C | Container {
    switch (data.containerType) {
      case ContainerTypes.Section: {
        return new Section(data);
      }
      case ContainerTypes.Step: {
        return new Step(data);
      }
      case ContainerTypes.RepeatingStep: {
        return new RepeatingStep(data);
      }
      case ContainerTypes.RepeatingStepChild: {
        return new RepeatingStepChild(data);
      }
      case ContainerTypes.FunctionCall: {
        return new FunctionCall(data);
      }
      case ContainerTypes.Scenario: {
        return new Scenario(data);
      }
      default: {
        throw new Error(`Invalid container type '${data.containerType}'`);
      }
    }
  }
}
